import type { RegisteredFeatureFlagKey } from '@trello/feature-flag-client';

import type { TouchpointSourceType } from '../TouchpointSourceType';

type Extends<T, U extends T> = U;

type FeatureFlagsTouchpoints = Extends<
  RegisteredFeatureFlagKey,
  'xf.cffe-for-1p-ads' | 'xf.cffe-for-funnel-experiment'
>;

const featureFlagsTouchpoints: Record<
  FeatureFlagsTouchpoints,
  TouchpointSourceType[]
> = {
  ['xf.cffe-for-1p-ads']: [
    'memberHomeWorkspaceSidebarSection',
    'templateCategoryScreen',
    'viewSwitcherAddAndEditViewsInlineDialog',
    'createMenuInlineDialog',
    'createBoardInlineDialog',
    'cardBackDatePicker',
    'pluginMenuScreen',
    'boardDirectory',
  ],
  ['xf.cffe-for-funnel-experiment']: ['cardBackDatePicker'],
};

export const isSourceTargetedByFeatureFlag = ({
  flagName,
  source,
}: {
  flagName: FeatureFlagsTouchpoints;
  source: TouchpointSourceType;
}) => featureFlagsTouchpoints[flagName]?.includes(source);
